<article class="associated-job widget-container" [ngClass]="{ 'empty-state': ragBreakdownItems?.length === 0, 'no-cards': !showCards }">
  @if (ragBreakdownItems?.length > 0) {
    <header class="associated-item-header">
      <div class="header-content">{{ title }}</div>
      <div class="widget-count">{{ totalItems }}</div>
    </header>
    <div class="associated-item-wrapper custom-scrollbar">
      <div class="associated-item-section">
        <div
          *ngFor="let breakdown of ragBreakdownItems; index as i"
          [ngClass]="{
            'job-item': true,
            'last-item': i > 4 && i === ragBreakdownItems.length - 1,
          }"
        >
          <div class="widget-header">
            <span class="widget-label">{{ breakdown?.title }}</span>
            <span class="percentage-completed" *ngIf="showPercentageOfCompletionInCards">
              {{
                T.settings.imports_and_exports.import_guides.percentage_complete_with_input
                  | translate
                    : {
                        number: (breakdown.percentageOfCompletion | percent),
                      }
              }}
            </span>
            <span class="percentage-completed">{{ breakdown.count }}</span>
          </div>
          <app-rag-breakdown-bar
            *ngIf="showCards"
            [displayCount]="false"
            [canClickRag]="false"
            [isWithinEventDetails]="true"
            [ragBreakdowns]="breakdown?.ragBreakdowns">
          </app-rag-breakdown-bar>
        </div>
      </div>
    </div>
    <footer class="associated-item-footer ion-justify-content-center">
      <app-button-transparent
        (clicked)="viewAll(objectType)"
        [text]="viewAllText"
        [icon]="'chevron_right'"
        [dropdown]="false"
        [reverseIconPlacement]="true"
      ></app-button-transparent>
    </footer>
  } @else if (showEmptyState && showCards) {
    <div class="centered-column mb-2">
      <span class="associated-item-title">{{ T.common.no | translate }} {{ title }}</span>
      <!-- <span class="associated-item-text-muted">{{
                  T.common.event_details_no_incident_text | translate
                }}</span> -->
    </div>
    <ng-content />
  } @else if (!showCards) {
    <span class="widget-icon material-symbols-outlined mr-1">{{ icon }}</span>
      <span class="widget-label">{{ title }}</span>
      <span class="widget-count">{{ headerCount }}</span>
  }
</article>
